import { createContext } from 'react';

export const AccordionContext = createContext(null);
